import i18n from '../../../../i18n';
import { fetchApi } from '../../../../lib/fetchApi';
import { ExtractFnReturnType, QueryConfig } from '../../../../lib/react-query';
import { DownloadCsvSource } from '../../../../types/DownloadCsvTypes';
import { FilterDto } from '../../../../types/FilterDto';
import { ImportedDataResultDto } from '../../../../types/ImportedDataResultDto';
import { Pagination, PaginationFilterDto } from '../../../../types/Pagination';
import { downloadCsvFile } from '../../../../utils/downloadCsvFile';
import { ParticipantDeleteItemDto, ParticipantDeleteReturn, ParticipantFormData, ParticipantsListFields } from '../types';
import { useQuery } from '@tanstack/react-query';

export const getParticipants = async (body: PaginationFilterDto): Promise<Pagination<ParticipantsListFields>> => {
    const response = await fetchApi.post(`/participant`, body) as Pagination<ParticipantsListFields>;
    return response;
};

export const deleteLogicParticipant = async (body: ParticipantDeleteItemDto): Promise<ParticipantDeleteReturn> => {
    const response = await fetchApi.put(`/participant`, body) as ParticipantDeleteReturn;
    return response;
};

export const createParticipant = async (body: ParticipantFormData): Promise<ParticipantsListFields> => {
    const response = await fetchApi.post(`/participant/create`, body) as ParticipantsListFields;
    return response;
};

export const updateParticipant = async (idParticipant: string, body: ParticipantFormData): Promise<ParticipantFormData> => {
    const response = await fetchApi.put<ParticipantFormData>(`/participant/${idParticipant}`, body, {
        params: { idParticipant },
    });
    return response;
};

export const getParticipantDetails = async (idParticipant: string) => {
    const data = await fetchApi.get(`/participant/${idParticipant}`) as ParticipantFormData;
    console.log("GET /participant response:", data);
    return data; 
}

export const uploadCsvFile = async (file: File, campaing: string): Promise<ImportedDataResultDto> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaing', campaing);

    const response = await fetchApi.post(`/participant/uploadCsv`, formData) as ImportedDataResultDto;
    return response;
};

export const exportCsv = async (filters: PaginationFilterDto): Promise<void> => {
    try {
        const result = await fetchApi.post<DownloadCsvSource>(`/participant/exportCsv`, filters, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        downloadCsvFile(result, "participants_export.csv");
    } catch (error) {
        console.error("Error downloading CSV", error);
    }
};

export const getParticipantsFilters = async (): Promise<FilterDto[]> => {
    const response = await fetchApi.get('/participant/filters') as { filters: FilterDto[] };;
    return response.filters;
}

type QueryFnType = typeof getParticipantsFilters;

type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useParticipantFilters = (config?: UseFiltersOptions) =>
    useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["participantFilters", i18n.language],
        queryFn: () => getParticipantsFilters(),
    });